import "./AddPGI.scss";

import { Checkbox, Datepicker, MbscCalendarEvent } from "@mobiscroll/react";
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import AsyncTypeahead, { DataListType } from "../../components/AsyncTypeahead";
import { ToastConfig } from "../../components/Toaster";
import { createPgiApi } from "../../api-helpers/PgiApiHelper";
import { Goal, Intervention, PgiRequest, Problem } from "pgi-experience-client";
import { createUsersApi } from "../../api-helpers/UserApiHelper";
import MultiSelectDropdown from "../../components/MultiselectDropdown";
import Pills from "../../components/Pills";
export interface PatientIdProps {
  patientId?: string;
  onSubmitPgi: (toasterConfig: ToastConfig) => Promise<void>;
  setOffCanvasShow: Dispatch<SetStateAction<boolean>>;
  loadPgis: () => void;
}
export const AddPGI = (props: PatientIdProps) => {
  const pgiApi = createPgiApi();
  const coach = createUsersApi();

  const [validated, setValidated] = useState(false);
 
  const [pgiForms, setPgiForms] = useState({} as PgiRequest)
  const [goal, setGoal] = useState(Array<Goal>);
  const [problem, setProblem] = useState(Array<Problem>);
  const [intervention, setIntervention] = useState(Array<Intervention>);
  const [coachList, setCoachList] = useState<DataListType[]>([]);
  const [validCoach, setValidCoach] = useState<boolean>(true);
  const [defaultAssigneeValue, setDefaultAssigneeValue] = useState<string>("");
  const [openPGIPicker, setOpenPGIPicker] = useState<boolean>(false);
  const [openIntsPicker, setOpenIntsPicker] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedInterventions, setSelectedInterventions] = useState<Record<string, Intervention>>({})
  const [problemsDropDown,setProblemsDropDown] = useState<string[]>(["Select problem"])
  const [error, setError] = useState({
    goalDueDate: false,
    interventionDueDate: false,
    interventionDropdown: ""
  });

  const selectCoach = (selected: any) => {
    setPgiForms({
      ...pgiForms,
      assigneeUserId: selected && selected.key,
    });
  };
  const loadCoachesList = async (query: string) => {
    if (pgiForms.assigneeUserId) {
      setPgiForms({ ...pgiForms, assigneeUserId: "" });
    }
    if (!query) {
      setCoachList([]);
      return;
    }
    try {
      const response = await coach.usersControllerSearchUsers(undefined, query);
      const result = response.data.map((result: any) => ({
        key: result.key,
        value: result.value,
      }));
      setCoachList(result);
    } catch (error) {
      console.log(error);
    }
  };
  const dateRangeChangeHandlar = (name: string, event: MbscCalendarEvent) => {
    const selectedDate = new Date(event.value);
    const utcDate = new Date(
      Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      )
    );
    setPgiForms({
      ...pgiForms,
      [name]: utcDate,
    });
    if(event.value){
      setError({
        ...error,
        [name]: false
      });
    }
  };
  const handleDiscard = () => {
    props.setOffCanvasShow(false);
  };

  const handleInputChange = async (
    e:
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setPgiForms((prevState: PgiRequest) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    console.log("hari pgiForms",Object.keys(selectedInterventions));
    event.preventDefault();
    setValidated(true);
    setError({
      ...error,
      goalDueDate: !pgiForms.goalDueDate,
      interventionDueDate: !pgiForms.interventionDueDate
    });
    const form = event.currentTarget;
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    setValidCoach(true);
    if (!pgiForms.assigneeUserId) {
      pgiForms.assigneeUserId && setValidCoach(false);
      return;
    }
    if (error.goalDueDate || error.interventionDueDate) {
      return;
    }
    pgiForms.assigneeUserId &&
    setDefaultAssigneeValue(
      coachList.filter((assignee) => assignee.key == pgiForms.assigneeUserId)[0]
      ?.value
    );
    var goalCommentSet=false;
    const pgiFormData:PgiRequest[] = []
    if(Object.keys(selectedInterventions).length){
      for(var id in Object.keys(selectedInterventions)){
        if(goalCommentSet) {
          delete pgiForms.goalComment
        }
        pgiFormData.push({...pgiForms, interventionId:Object.keys(selectedInterventions)[id]})
        goalCommentSet=true;
      }
    }

    try {
      await pgiApi.pgiControllerAddPgi(pgiFormData,props.patientId!);
      const toasterConfig = {
        type: "success",
        title: "PGI added successfully!",
        icon: "check_circle_outline",
      };
      props.onSubmitPgi(toasterConfig as ToastConfig);
      props.loadPgis();
      props.setOffCanvasShow(false);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message?.message?.message;
      const toasterConfig: ToastConfig = {
        type: "danger",
        title: errorMessage,
        icon: "error_outline",
      };
      props.onSubmitPgi(toasterConfig as ToastConfig);
    }
  };

  const getProblems = async () => {
    try {
      const problemResponse = await pgiApi.pgiControllerGetProblems();
      await setProblem(problemResponse.data);
      return problemResponse.data;
    } catch (error) {
      console.error(error);
    } 
  };

  const problemsCallback = (inp:string) => {
    if(inp.length){
      const filteredProvlems= problem.filter((problem:Problem)=>problem.name.toLowerCase().includes(inp.toLowerCase())).map(prob=>prob.name);
      setProblemsDropDown([...filteredProvlems])
    }
  }

  const getGoals = async (problemId: string) => {
    if (!problemId) return;
    setSelectedInterventions({...{}})
      setPgiForms((prevState: PgiRequest) => ({
        ...prevState,
        ['problemId']: problemId,
      }));
    await setPgiForms((prevState: PgiRequest) => ({
      ...prevState,
      problemId: problemId,
      interventionId: "",
      goalId:""
    }));
    setIntervention([])
    if(problemId !== "") {
      try {
        const response = await pgiApi.pgiControllerGetGoalsByProblemId(problemId);
        await setGoal(response.data);
        console.log(goal);
      } catch (error) {
        console.error(error);
      } 
    } else {
      setGoal([])
      setIntervention([])
    }
  };
  const getInterventions = async (problemId: string, goalId: string) => {
    setSelectedInterventions({...{}})
    setPgiForms((prevState: PgiRequest) => ({
      ...prevState,
      interventionId: "",
      goalId: goalId,
    }));
    setIntervention([])
    if(problemId !== "" || goalId !== ""){
      try {
        const response = await pgiApi.pgiControllerGetInterventionByGoalId(
          problemId,
          goalId
        );
        await setIntervention(response.data);
      } catch (error) {
        console.error(error);
      } 
    } else {
      setIntervention([])
    }
  };

  useEffect(() => {
    getProblems();
  }, []);
  const toggleSelect = (option:Intervention) => {
    setSelectedInterventions((prev) =>
      Object.keys(prev)?.includes(option.id)
        ? (delete prev[option.id], { ...prev })
        : { ...prev, [option.id]: option }
    );
  };
  
  return (
    <Form
      className="d-flex flex-column h-100"
      noValidate
      validated={validated}
      onSubmit={submitHandler}
    >
      <div className="flex-fill" >
        <div className="text-center mb-2 border-strike">
          <strong className="fs-13 bg-white px-1 position-relative z-index-1">
            Problem
          </strong>
        </div>
        <div className="mb-3">
          <label
            htmlFor="problem"
            className="form-label fs-12 fw-semibold mb-1"
          >
            Problem
          </label>
          <select
              className="form-select form-select-sm "
              name="problemId"
              value={pgiForms.problemId}
              onChange={(e) => {
                const selectedValue = e.target.value;
                problemsCallback(selectedValue)
                getGoals(selectedValue); // First method
              }}
              required={true}
            >
              <option value="" selected>
                Select Problem
              </option>
              {problem.map((problem, index) => (
                <option key={index} value={problem.id}>
                  {problem.name}
                </option>
              ))}
            </select>
        </div>
        <div className="text-center border-strike">
          <strong className="fs-13 bg-white px-1 position-relative z-index-1">
            Goal
          </strong>
        </div>
        <div className="row g-2 mb-3">
          <div className="col-7">
            <label
              htmlFor="categoryId"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Goal
            </label>
            <select
              className="form-select form-select-sm "
              name="goalId"
              value={pgiForms.goalId}
              onChange={(e) => {
                const selectedValue = e.target.value;
                handleInputChange(e); // First method
                // setSelectedGoal(selectedValue)
                getInterventions(pgiForms.problemId, selectedValue); // Second method
              }}
              required={true}
            >
              <option value="" selected>
                Select Goal
              </option>
              {goal.map((goal, index) => (
                <option key={index} value={goal.id}>
                  {goal.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-5">
            <label
              htmlFor="goalDueDate"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Due Date
            </label>
            <div className={"mobiscroll " + (error.goalDueDate ? 'wrapper-for-invalid-date' : '')}>
              <div className="mobiscroll__calendar">
                <Datepicker
                  controls={["calendar"]}
                  name="goalDueDate"
                  calendarType="month"
                  theme="windows"
                  themeVariant="light"
                  onChange={(e) => dateRangeChangeHandlar('goalDueDate', e)}
                  placeholder="MM/DD/YYYY"
                  display="bubble" // Can be 'inline', 'center', 'bubble', etc.
                  touchUi={true} // Enables touch-friendly UI
                  showOnClick={false}
                  isOpen={openPGIPicker}
                  onClose={() => {setOpenPGIPicker(false)}}
                  buttons={[]} // Disables the Set and Cancel buttons
                  min={new Date()} // TODO: Add Validation for due date
                  required
                />
              </div>
                 <div onClick={() => setOpenPGIPicker(!openPGIPicker)} className="mobiscroll__calendar-icon">
                    <span className="material-symbols-outlined fs-18" >
                      calendar_month
                    </span>
                  </div>
            </div>
          </div>
          <div className="col-12">
            <label
              htmlFor="Notes"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Comments
            </label>
            <textarea
              name="goalComment"
              className="form-control form-control-sm"
              id="goalComment"
              placeholder="Type comment here..."
              rows={3}
              onChange={(e) => handleInputChange(e)}
            ></textarea>
          </div>
        </div>
        <div className="text-center border-strike">
          <strong className="fs-13 bg-white px-1 position-relative z-index-1">
            Intervention
          </strong>
        </div>
        <div className="row g-2 mb-3">
          <div className="col-7">
            <label htmlFor="task" className="form-label fs-12 fw-semibold mb-1">
              Intervention
            </label>
            <MultiSelectDropdown
              selectedValues={selectedInterventions}
              allValues={intervention}
              callback={toggleSelect}
              required={true}
              defaultValue="Select Intervention"
            />
          </div>
          <div className="col-5">
            <label
              htmlFor="interventionDueDate"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Due Date
            </label>
            <div className={"mobiscroll " + (error.interventionDueDate ? 'wrapper-for-invalid-date' : '')}>
              <div className="mobiscroll__calendar">
                <Datepicker
                  controls={["calendar"]}
                  name="interventionDueDate"
                  calendarType="month"
                  theme="windows"
                  themeVariant="light"
                  onChange={(e) =>dateRangeChangeHandlar('interventionDueDate', e)}
                  placeholder="MM/DD/YYYY"
                  display="bubble" // Can be 'inline', 'center', 'bubble', etc.
                  touchUi={true} // Enables touch-friendly UI
                  showOnClick={false}
                  isOpen={openIntsPicker}
                  onClose={() => {setOpenIntsPicker(false)}}
                  buttons={[]} // Disables the Set and Cancel buttons
                  min={new Date()} // TODO: Add Validation for due date
                  required
                />
              </div>
                  <div onClick={() => setOpenIntsPicker(!openIntsPicker)} className="mobiscroll__calendar-icon">
                    <span className="material-symbols-outlined fs-18" >
                      calendar_month
                    </span>
                  </div>
            </div>
          </div>
          <div className="col-12">
            <Pills 
              allValues={selectedInterventions}
              handleClose={toggleSelect}
            />
            
          </div>
          <div className="col-12">
            <div className="mb-3">
              <label
                htmlFor="assignTo"
                className="form-label fs-12 fw-semibold mb-1"
              >
                Assignee
              </label>
              <AsyncTypeahead
                name="assigneeUserId"
                options={coachList}
                onSelect={selectCoach}
                callback={loadCoachesList}
                placeholder={"Search Assignee"}
                defaultValue={defaultAssigneeValue}
                required={true}
                isValid={validCoach}
              ></AsyncTypeahead>
            </div>
            <div className="mb-3">
              <label
                htmlFor="Notes"
                className="form-label fs-12 fw-semibold mb-1"
              >
                Comments
              </label>
              <textarea
                name="interventionComment"
                className="form-control form-control-sm"
                id="interventionComment"
                placeholder="Type comment here..."
                rows={3}
                onChange={(e) => handleInputChange(e)}
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
        <div>
          <button
            className="btn btn-sm btn-outline-secondary rounded-pill px-5 fs-13"
            type="reset"
            onClick={handleDiscard}
          >
            Discard
          </button>
        </div>
        <div>
          <button
            className="btn btn-sm btn-secondary rounded-pill ps-4 pe-5 fs-13"
            type="submit"
          >
            <span className="material-symbols-outlined fs-16 align-text-top">
              add
            </span>
            Add PGI
          </button>
        </div>
      </div>
    </Form>
  );
};
